export const STORE_EXPERT_COURSE_FAILED = 'store_expert_course_failed';
export const STORE_EXPERT_COURSE_PENDING = 'store_expert_course_pending';
export const STORE_EXPERT_COURSE_LOADED = 'store_expert_course_loaded';
